export default function convertBooleanToText(value: boolean): string {
    return value ? "Yes" : "No";
}